<template>
  <v-container fluid>
    <v-row>
      <v-col cols="11">
        <v-tabs v-model="tab">
          <v-tab>limia</v-tab>
          <v-tab>mamatena</v-tab>
          <v-tab>smartnews</v-tab>

          <v-tabs-items v-if="siteId" v-model="tab">
            <v-tab-item>
              <format-setting :site-id="siteId" format-name="limia" />
            </v-tab-item>
            <v-tab-item>
              <format-setting :site-id="siteId" format-name="mamatena" />
            </v-tab-item>
            <v-tab-item>
              <format-setting :site-id="siteId" format-name="smartnews" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'
import formatSetting from './formatSetting'
import headUtilsMixin from '@/mixins/head_utils'

export default {
  components: {
    formatSetting
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: 'RSS設定',
      siteId: null,
      tab: null
    }
  },
  mounted: function () {
    axios.get('/api/site_reference').then(
      ({ data }) => {
        this.siteId = data.data.attributes.id
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `サイト情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  }
}
</script>

<style scoped></style>
